/**
 * Transform naming of object keys to css vars style
 */
export const objectToCssVars = vars => {
  return Object.entries(vars).reduce(
    (accum, [name, value]) => ({
      ...accum,
      [`--${name}`]: `${value}`,
    }),
    {}
  );
};
